<template>
  <el-table
    :data="items"
    border
    style="width: 100%"
    cell-class-name="table-small-cell"
  >
    <el-table-column
      align="center"
      prop="drill_type_name"
      min-width="80"
      label="钻头类型"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="fix_base_name"
      min-width="80"
      label="维修基地"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="drill_size"
      min-width="90"
      label="规格"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="model_number"
      min-width="120"
      label="型号"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="component_number"
      min-width="100"
      label="零件号"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="drill_number"
      min-width="80"
      label="总 / 到达"
    >
      <template slot-scope="scope">
        {{ scope.row.drill_number }} / {{ scope.row.drill_receive_number }}
      </template>
    </el-table-column>
    <el-table-column
      align="center"
      prop="block_info"
      min-width="80"
      label="使用区块"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="cut_info"
      min-width="100"
      label="下料"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="old_drill_serial_number"
      min-width="120"
      label="旧序列号"
    >
      <template slot-scope="scope">
        <DrillLink
          :no="scope.row.old_drill_serial_number"
          v-if="scope.row.is_drill_new == 2"
        ></DrillLink>
      </template>
    </el-table-column>
    <el-table-column
      align="center"
      prop="old_drill_serial_number"
      min-width="100"
      label="序列号"
    >
      <template slot-scope="scope">
        <DrillLink
          v-for="drill in scope.row.drills"
          :key="drill.serial_number"
          :no="drill.serial_number"
          >{{ drill.serial_number }}</DrillLink
        >
      </template>
    </el-table-column>
    <el-table-column
      align="center"
      prop="deliver_time"
      min-width="96"
      label="交货时间"
    >
      <template slot-scope="scope">
        {{ scope.row.deliver_time ? scope.row.deliver_time : '-' }}
      </template>
    </el-table-column>
    <el-table-column
      align="center"
      prop="sale_type_info"
      min-width="80"
      label="销售类型"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="nozzle_install_info"
      min-width="80"
      label="安装方式"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="nozzle"
      min-width="100"
      label="喷嘴"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="package_type_info"
      min-width="90"
      label="包装"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="remark"
      min-width="90"
      label="备注"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="status_name"
      min-width="100"
      label="进度"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="option_status_name"
      min-width="80"
      label="状态"
    ></el-table-column>
    <el-table-column
      align="center"
      prop="created_at"
      min-width="140"
      label="创建时间"
    >
      <template slot-scope="scope">
        {{ $time(scope.row.created_at).format('YYYY-MM-DD HH:mm') }}
      </template>
    </el-table-column>
    <el-table-column
      align="center"
      fixed="right"
      label="操作"
      width="150"
      class-name="option-flex"
    >
      <template slot-scope="scope">
        <btn-tag
          :href="'/order_demands/' + scope.row.id"
          text="详情"
          :key="Math.random()"
          :auth-id="31101"
          module-name="orders"
        ></btn-tag>
        <btn-tag
          :href="'/order_demands/' + scope.row.id + '/edit'"
          text="编辑"
          :key="Math.random()"
          :auth-id="31101"
          module-name="orders"
          v-if="scope.row.status == 0"
        ></btn-tag>
        <btn-tag
          :btn="true"
          text="删除"
          :key="Math.random()"
          :auth-id="31101"
          btn-class="btn-danger"
          module-name="orders"
          @click.native="hanldeDelte(scope.row, scope.$index)"
          v-if="scope.row.status == 0"
        ></btn-tag>
        <btn-tag
          :btn="true"
          text="提交需求"
          :key="Math.random()"
          :auth-id="31101"
          btn-class="btn-info"
          module-name="orders"
          @click.native="hanldeUpdate(scope.row, scope.$index, 1)"
          v-if="scope.row.status == 0"
        ></btn-tag>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import {
  orderDelete,
  orderLaunch,
  orderCheck,
  orderApprove,
  orderFactory,
} from '@/service/getData'

export default {
  props: {
    items: null,
  },
  methods: {
    hanldeUpdate(item, index, status) {
      let that = this
      let data = { id: item.id }
      that.$dialog.confirm('确认该操作吗？').then(function (dialog) {
        orderLaunch(data).then((res) => {
          if (res.status == 0) {
            that.$dialog.alert('提交成功，请等待审核')
            that.$set(that.items, index, res.data)
          }
        })
      })
    },
    hanldeDelte(item, index) {
      let that = this
      that.$dialog.confirm('确认删除吗').then(function (dialog) {
        orderDelete(item.id).then((res) => {
          if (res.status == 0) {
            that.items.splice(index, 1)
          }
        })
      })
    },
  },
}
</script>
<style scoped>
.alink {
  display: block;
}
</style>
<style >
td.option-flex .cell {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
</style>